export class CustomerListModel {
  OrgId: number;
  OrgName: string;
  OrgParentId: number;
}
